export const SCHOOL_YEAR_OPTION_COUNT = 6;

export const getCurrentSchoolYearStartYear = (today = new Date()) => (
  today.getMonth() >= 8 ? today.getFullYear() : today.getFullYear() - 1
);

export const getOldestSupportedSchoolYearStartYear = (
  today = new Date(),
  count = SCHOOL_YEAR_OPTION_COUNT,
) => getCurrentSchoolYearStartYear(today) - (count - 1);

export const getCurrentSchoolYearStart = (today = new Date()) => (
  `${getCurrentSchoolYearStartYear(today)}-09-01`
);

export const buildSchoolYearLabel = (startYear) => (
  `${startYear}/${String(startYear + 1).slice(-2)}`
);

export const buildSchoolYearRange = (startYear) => ({
  startYear,
  fromDate: `${startYear}-09-01`,
  tillDate: `${startYear + 1}-08-31`,
  label: buildSchoolYearLabel(startYear),
});

export const normalizeSchoolYearStartYear = (
  value,
  today = new Date(),
  count = SCHOOL_YEAR_OPTION_COUNT,
) => {
  const parsed = Number.parseInt(value, 10);
  const currentStartYear = getCurrentSchoolYearStartYear(today);
  const oldestSupportedStartYear = getOldestSupportedSchoolYearStartYear(today, count);

  if (Number.isNaN(parsed)) return currentStartYear;
  if (parsed > currentStartYear || parsed < oldestSupportedStartYear) return currentStartYear;

  return parsed;
};

export const buildSchoolYearOptions = (today = new Date(), count = SCHOOL_YEAR_OPTION_COUNT) => {
  const currentStartYear = getCurrentSchoolYearStartYear(today);

  return Array.from({ length: count }, (_, index) => {
    const startYear = currentStartYear - index;

    return {
      value: startYear,
      text: buildSchoolYearLabel(startYear),
    };
  });
};

export const getDefaultSchoolClassesFilters = (
  today = new Date(),
  activeSchoolYearRange = buildSchoolYearRange(getCurrentSchoolYearStartYear(today)),
) => ({
  search: "",
  dayOfWeek: "",
  classTypeId: "",
  startTime: "",
  endTime: "",
  teacherId: "",
  showOnlyNotRepeating: false,
  showOnlyRepeating: false,
  fromDate: activeSchoolYearRange.fromDate,
  tillDate: activeSchoolYearRange.tillDate,
  comment: false,
});
